import { Pipe, PipeTransform } from '@angular/core';
import { DataDictService } from '../../services/service/data-dict.service';

@Pipe({ name: 'dictConvert' })
export class DictConvertPipe implements PipeTransform {
  constructor(private dataDictService: DataDictService){}

  transform(value: any, dictKind: string,  format?: string, cascader?:boolean): Promise<string> {
    if(dictKind == null) return Promise.resolve(value);
    return this.dataDictService.getItem(dictKind, value).toPromise().then(item=>{
        if(!cascader) return this.dataDictService.parseItemText(dictKind, item, format);
        const paths = this.dataDictService.getDictItemMuiltiLevelPath(dictKind, value).map(x=>{
           return this.dataDictService.parseItemText(dictKind, x, format);
        });
        return paths.join(" / ");
    });
  }
}
